import React from 'react';
import ReactDOM from 'react-dom/client';  // Updated import
import './index.css';
import { Provider } from "react-redux";
import store from "./store/index";
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // allows Toastify CSS styles
import App from './App';

let persistor = persistStore(store);

// Use createRoot instead of render
const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.Fragment>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
    <ToastContainer />
  </React.Fragment>
);
